import MyNotificationsPopUpContent from "./MyNotificationsPopUpContent";

export default MyNotificationsPopUpContent;
